<div class="modal-header">
    <button type="button" class="close pull-right" aria-label="Close" (click)="decline()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="container-fluid py-15 text-center">
    {{"Hai accettato l'invito con codice"}} {{message}}
  </div>
  <div class="modal-footer d-flex justify-content-between">
    <button (click)="decline()" class="btn-solid btn-small" style="margin: auto;">
      {{'general.close' | translate}}
    </button>
  </div>